import './css/styles.scss';

function lankRadInit() {}

lankRadInit();
